const BrochureType={
    FavouritesAllPlots:1,
    Favourites:2,
    FavouritesAllHouseTypes:3,
    Configurator:4
};
BrochureType.getString = function(brochureType){
	switch(brochureType){
		case BrochureType.FavouritesAllPlots:
			return 'All Plots';
		case BrochureType.Favourites:
			return 'Favourites';
		case BrochureType.FavouritesAllHouseTypes:
			return 'All House Types';
		case BrochureType.Configurator:
			return 'Configurator';
		default:
			throw new Error('Not implemented');
	}
};
export default BrochureType;